import { render, staticRenderFns } from "./topsalesbycustomer.vue?vue&type=template&id=579cc2f7"
import script from "./topsalesbycustomer.vue?vue&type=script&lang=js"
export * from "./topsalesbycustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports